module.exports = __webpack_public_path__ + "img/registered-MASK.23789ba0.png";